import Vue from 'vue'
import Vuex from 'vuex'
import { texts } from './utilities/Texts'
import toLower from 'lodash/toLower'
import upperFirst from 'lodash/upperFirst' 

Vue.use(Vuex)

const state = {
  dateTimeOnServer: new Date(), // Only for legacy support
  texts: texts,
  lang: 'nb', // default language,
  fares: [
    {
      id: '3d2fe8d3-c3c9-44b8-917c-725d859376ba',
      isDefault: true,
      count: 1
    },
    {
      id: 'b942bbca-99df-446f-99e8-ee8191066fa6',
      isDefault: false,
      count: 0
    },
    {
      id: '21650b77-1a9b-48eb-972f-d5ea43a78faf',
      isDefault: false,
      count: 0
    },
    {
      id: '83d3e907-afd2-4e26-9d73-c812efa9fc83',
      isDefault: false,
      count: 0
    },
    {
      id: '89c95211-ea6a-49d8-a46d-2513b82e8e39',
      isDefault: false,
      count: 0
    },
    {
      id: 'b06ed0cd-5b19-4d43-91d1-e7b318d1cb5e',
      isDefault: false,
      count: 0
    },
    {
      id: '2beab689-2023-421a-8112-6efbca15e961',
      isDefault: false,
      count: 0
    }
  ],
}
const getters = {
  text: state => (key) => {
    let keyLower = toLower(key)
    let item = state.texts[keyLower] ? state.texts[keyLower][state.lang] : undefined
    if (item) {
      let firstIsUpper = key.length > 0 ? key.charAt(0) === key.charAt(0).toUpperCase() : false
      return firstIsUpper ? upperFirst(item) : item
    }
    return key
  },
  lang: state => state.lang,
  fares: (state, getters) => {
    return state.fares.map(fare => {
      fare.name = getters.text(`Fare-${fare.id}-name`)
      fare.helpText = getters.text(`Fare-${fare.id}-text`)
      return fare
    })
  },
  dateOnServer: (state)  => {
    return state.dateTimeOnServer.toISOString().split('T')[0]
  },
}

const mutations = { 
  decreaseFare(state, fare) {
    fare.count --
  },
  increaseFare(state, fare) {
    fare.count ++
  },
  setLanguage (state, lang) {
    if (lang.toLowerCase() === 'en-us') {
      state.lang = 'en'
    } else {
      state.lang = lang
    }
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
})

export default store